import { Box, Flex } from '@chakra-ui/layout';
import { Button, Card, CardBody } from '@chakra-ui/react';
import React, { useState } from 'react';

import { Alert } from 'packages/common-frontend/components/Alert';
import { Select } from 'packages/common-frontend/components/Select';
import { Typography } from 'packages/common-frontend/components/Typography';
import { PARTY_OPTIONS } from '~/core/routes/settings/implementations/common/types';
import { WizardComponent } from '~/core/routes/settings/implementations/create/ImplementationWizard';

export const AssignParties: WizardComponent = ({
  selectedOrgs,
  setSelectedOrgs,
  previousStep,
  nextStep,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const hasBorrower = selectedOrgs.some((org) => org.type === 'borrower');
  const hasCapitalProvider = selectedOrgs.some(
    (org) => org.type === 'capitalProvider',
  );
  const isInvalid = !hasBorrower || !hasCapitalProvider;

  return (
    <Flex direction="column" width="100%" gap="1rem" height="100vh">
      <Box>
        <Typography variant="page-title">Assign Parties</Typography>
        <Typography variant="base-muted">
          Assign party roles to organizations in the facility.
        </Typography>
      </Box>
      <Card variant="outline" size="lg">
        <CardBody>
          <Box pb="0.4rem">
            <Typography variant="base" fontWeight="bold">
              Select Organizations
            </Typography>
          </Box>
          {selectedOrgs.map((org) => {
            const orgName = org.name;
            const options =
              hasBorrower && org.type !== 'borrower'
                ? PARTY_OPTIONS.filter((opt) => opt.value !== 'borrower')
                : PARTY_OPTIONS;

            return (
              <Flex
                key={org.name}
                justify="space-between"
                py="0.2rem"
                align="center"
              >
                <Typography variant="base" fontWeight="bold">
                  {orgName}
                </Typography>
                <Box width="50%">
                  <Select
                    value={org.type}
                    placeholderLabel="Select Party Role"
                    onChange={(value) =>
                      setSelectedOrgs((prevOrgs) => {
                        const updatedOrgs = prevOrgs.map((prevOrg) =>
                          prevOrg.name === orgName
                            ? { ...prevOrg, type: value }
                            : prevOrg,
                        );

                        return updatedOrgs;
                      })
                    }
                    options={options}
                    width="100%"
                  />
                </Box>
              </Flex>
            );
          })}
        </CardBody>
      </Card>
      {isInvalid && isSubmitted && (
        <Alert status="error">
          <Typography variant="base" fontWeight="bold">
            Facility setup requires at least one borrower and one lender
          </Typography>
        </Alert>
      )}
      <Flex justify="space-between">
        <Button onClick={previousStep}>Back</Button>
        <Button
          onClick={() => {
            setIsSubmitted(true);
            if (!isInvalid) nextStep();
          }}
          variant="primary"
          colorScheme="v2-aurora"
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
};
